module.exports = __webpack_public_path__ + "static/media/hero-image-01.d19ab334.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-image-01.svg
// module id = 26
// module chunks = 0